import type { JourneyId } from '@epilot/journey-logic-commons/src/types/next'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJourneyById } from '../services/journey-service'

type Response = Awaited<ReturnType<typeof getJourneyById>>

export const getJourneyByIdQueryKey = (id: JourneyId | undefined) => [
  'journey',
  id
]

export const useJourneyQuery = (
  id: JourneyId | undefined,
  options?: Omit<UseQueryOptions<Response>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: getJourneyByIdQueryKey(id),
    queryFn: (context) => {
      return getJourneyById(id, context.signal)
    },
    ...options
  })
}
